"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var field_list_1 = require("./field-list");
var getterCache = {};
// tslint:disable-next-line:no-string-literal
getterCache['undefined'] = function (obj) { return obj; };
/**
 * @hidden
 */
function getter(field) {
    if (getterCache[field]) {
        return getterCache[field];
    }
    var fields = field_list_1.fieldList(field);
    getterCache[field] = function (obj) {
        var result = obj;
        for (var idx = 0; idx < fields.length && result; idx++) {
            result = result[fields[idx]];
        }
        return result;
    };
    return getterCache[field];
}
exports.getter = getter;



//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-common@1.0.2/~/@progress/kendo-common/dist/npm/accessors/getter.js
// module id = 6405
// module chunks = 0